import React from 'react';
import { Form, InputNumber, Typography, Skeleton } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faPen } from '@fortawesome/free-solid-svg-icons';
import {
  SettingsCard,
  CardHeader,
  CardTitle,
  CardTitleText,
  InfoRow,
  InfoLabel,
  InfoValue,
  FormSection,
  SaveChangesButton,
  CancelButton,
  ActionButtons,
  StyledProgress,
  ActionIconButton,
} from '../Styles';
import { useTheme } from '../../../context/ThemeContext';
import type { TaxConfigurationSectionProps } from '../types';

const TaxConfigurationSection: React.FC<TaxConfigurationSectionProps> = ({
  user,
  editingSection,
  formData,
  loading,
  profileLoading,
  onEdit,
  onNumberChange,
  onSave,
  onCancel,
}) => {
  const { isDarkMode } = useTheme();
  const taxValue = user && user.tax !== undefined && user.tax !== null && !isNaN(user.tax) ? user.tax * 100 : 0;

  return (
    <SettingsCard>
      <CardHeader>
        <CardTitle>
          <FontAwesomeIcon icon={faChartLine} style={{ fontSize: 20, color: '#1890ff' }} />
          <CardTitleText level={4}>Tax Configuration</CardTitleText>
        </CardTitle>
        <ActionIconButton
          onClick={profileLoading ? undefined : onEdit}
          iconColor="#2D6CCA"
          style={{ opacity: profileLoading ? 0.5 : 1, cursor: profileLoading ? 'not-allowed' : 'pointer' }}
        >
          <FontAwesomeIcon icon={faPen} fontSize={14} color={isDarkMode ? '#fff' : '#222222'} />
        </ActionIconButton>
      </CardHeader>
      {editingSection !== 'tax' ? (
        <div>
          <InfoRow>
            <FontAwesomeIcon icon={faChartLine} style={{ fontSize: 16, color: '#1890ff' }} />
            <InfoLabel>Tax Rate:</InfoLabel>
            <InfoValue>
              {profileLoading ? (
                <Skeleton.Input active size="small" style={{ width: 100, height: 20 }} />
              ) : (
                taxValue > 0 ? `${taxValue.toFixed(2)}%` : 'Not set'
              )}
            </InfoValue>
          </InfoRow>
          <div style={{ marginTop: 16 }}>
            <Typography.Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 8 }}>
              Current tax rate applied to all transactions
            </Typography.Text>
            <StyledProgress percent={taxValue} strokeColor="#1890ff" />
          </div>
        </div>
      ) : (
        <FormSection>
          <Form.Item label="Tax Rate (%)">
            <InputNumber
              name="tax"
              value={formData.tax}
              onChange={(value) => onNumberChange('tax', value)}
              placeholder="Enter tax percentage"
              min={0}
              max={100}
              style={{ width: '100%' }}
            />
            <Typography.Text type="secondary" style={{ fontSize: 12, display: 'block', marginTop: 4 }}>
              Enter the tax percentage (0-100)
            </Typography.Text>
          </Form.Item>
          <ActionButtons>
            <SaveChangesButton icon={<CheckOutlined />} onClick={onSave} loading={loading}>
              Save Changes
            </SaveChangesButton>
            <CancelButton onClick={onCancel}>
              Cancel
            </CancelButton>
          </ActionButtons>
        </FormSection>
      )}
    </SettingsCard>
  );
};

export default React.memo(TaxConfigurationSection);

